export function SuggestedQuestions({
  questions,
  onPick
}: {
  questions: string[];
  onPick: (q: string) => void;
}) {
  if (questions.length === 0) return null;
  return (
    <div class="suggestions">
      <div class="suggestions-label">Popular questions</div>
      {questions.map((q) => (
        <button class="suggestion-chip" key={q} onClick={() => onPick(q)}>
          {q}
        </button>
      ))}
    </div>
  );
}
